import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { DELETE } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { DEACTIVATE_PROMOTION, DEACTIVATE_PROMOTION_FAIL,
         DEACTIVATE_PROMOTION_SUCCESS, FETCH_PROMOTIONS } from '../redux/Promotions';

function* DeactivatePromotionFlow({ payload, }) {
  try {
    const endpoint = `${apiRoot}/promotions/${payload}`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: DELETE, endpoint, });
    yield put(DEACTIVATE_PROMOTION_SUCCESS(response));
    yield put(FETCH_PROMOTIONS());
  } catch (error) {
    yield put(DEACTIVATE_PROMOTION_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* DeactivatePromotion() {
  yield takeLatest(DEACTIVATE_PROMOTION, DeactivatePromotionFlow);
}
